import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./PageIntro.css";

export default function PageIntro({
  eyebrow,
  title,
  description,
  actions = [],
  image,
  visual,
  children,
  tone = "light",
}) {
  return (
    <section className={`page-intro page-intro-${tone}`}>
      <div className="page-intro-inner">
        <div className="page-intro-copy">
          <span className="page-intro-eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          {description ? <p>{description}</p> : null}
          {children}
          {actions.length ? (
            <div className="page-intro-actions">
              {actions.map((action) => {
                const content = (
                  <>
                    {action.label} <FaArrowRight aria-hidden="true" />
                  </>
                );
                return action.external ? (
                  <a
                    className={`page-intro-action is-${action.variant || "secondary"}`}
                    href={action.href}
                    target={action.target}
                    rel={action.target === "_blank" ? "noreferrer" : undefined}
                    key={action.label}
                  >
                    {content}
                  </a>
                ) : (
                  <Link
                    className={`page-intro-action is-${action.variant || "secondary"}`}
                    to={action.href}
                    key={action.label}
                  >
                    {content}
                  </Link>
                );
              })}
            </div>
          ) : null}
        </div>
        {visual || image ? (
          <div className="page-intro-visual" aria-hidden={visual ? undefined : true}>
            {visual || <img src={image.src} alt="" className={image.className || ""} />}
          </div>
        ) : null}
      </div>
    </section>
  );
}
